import { useEffect, useRef, useState } from 'react';
import type { ReactNode } from 'react';
import { useMovimentoReduzido } from './movimento';

/** O conteúdo permanece legível mesmo quando não há IntersectionObserver. */
export function Revela({
  children,
  movimento = 'suave',
  direcao = 'esquerda',
}: {
  children: ReactNode;
  movimento?: 'suave' | 'cartao';
  direcao?: 'esquerda' | 'direita';
}) {
  const elemento = useRef<HTMLDivElement>(null);
  const [entrou, setEntrou] = useState(false);
  const reduzido = useMovimentoReduzido();
  const podeAnimar = !reduzido && typeof IntersectionObserver !== 'undefined';

  useEffect(() => {
    const alvo = elemento.current;
    if (!alvo || !podeAnimar) return;
    const observer = new IntersectionObserver(([entrada]) => {
      if (entrada?.isIntersecting) {
        setEntrou(true);
        observer.disconnect();
      }
    }, {
      threshold: movimento === 'cartao' ? 0.12 : 0,
      rootMargin: movimento === 'cartao' ? '0px 0px -64px 0px' : '0px 0px -40px 0px',
    });
    observer.observe(alvo);
    return () => observer.disconnect();
  }, [podeAnimar, movimento]);

  if (movimento === 'cartao') {
    return (
      <div ref={elemento} className="revela-card" data-direcao={direcao}
        data-aguardando={podeAnimar && !entrou}>
        {children}
      </div>
    );
  }

  return <div ref={elemento} className={entrou ? 'revela revela-visivel' : 'revela'}>{children}</div>;
}
